import { FormControl, FormControlProps } from '@chakra-ui/react'
import * as React from 'react'

import { TChakraAsProp } from '~ui/typings/chakra'

type TChakraProps = TChakraAsProp &
  Pick<FormControlProps, 'id' | 'isDisabled' | 'isRequired' | 'isInvalid' | 'label'>

type TProps = RequiredChildren & TChakraProps

/**
 * Chakra wrapper around Chakra input components
 * use to sync inputs, labels, messages etc
 *
 * examples in Form.stories or Chakra docs: https://chakra-ui.com/docs/form/form-control
 */
export const InputControl: React.FC<TProps> = ({ children, ...chakraProps }) => {
  return <FormControl {...chakraProps}>{children}</FormControl>
}
